import { useFilterStore } from "@/stores/filterStore";

// 조회 환경(PROD / STG) 스위처 + 배지 — 헤더에 항상 노출된다(2026-09-10, 결함 B).
//
// 목적: novadb 백오피스가 어느 환경의 데이터를 보고 있는지 화면에서 즉시 알 수 있게 한다.
// staging.ainova.news 백엔드는 nova-*-stg 에서 차감하는데 백오피스는 그동안 prod 만 보여
// "충분한데 부족" 착시가 났다. 이제 STG 를 골라 stg 원장을 직접 확인할 수 있다.
//
// 안전 원칙(STG VIEW = READ ONLY): STG 를 보는 동안에는 모든 쓰기/관리 액션이 비활성화되고,
// 백엔드도 env=stg 쓰기 요청을 403 으로 거부한다. 화면이 STG 인데 write 를 눌러 실제 prod
// 데이터를 바꾸는 사고를 원천 차단한다.
export default function EnvSwitcher() {
  const env = useFilterStore((s) => s.env);
  const setEnv = useFilterStore((s) => s.setEnv);
  const isStg = env === "stg";

  return (
    <div className="flex items-center gap-2" data-testid="env-switcher">
      {/* 현재 환경 배지 — 끌 수 없이 항상 노출. STG 는 경고(주황) 스타일. */}
      <span
        data-testid="env-badge"
        data-env={env}
        className={
          isStg
            ? "inline-flex items-center gap-1 rounded-md border border-amber-300 bg-amber-100 px-2 py-1 text-xs font-bold text-amber-800"
            : "inline-flex items-center gap-1 rounded-md border border-emerald-200 bg-emerald-50 px-2 py-1 text-xs font-bold text-emerald-700"
        }
        title={isStg ? "스테이징(STG) 데이터를 조회 중입니다 — 조회 전용" : "운영(PROD) 데이터를 조회 중입니다"}
      >
        {isStg ? "STG · 조회 전용" : "PROD"}
      </span>

      {/* 토글 스위처 */}
      <div className="flex overflow-hidden rounded-md border border-ink-200 text-xs">
        <button
          type="button"
          data-testid="env-btn-prod"
          onClick={() => setEnv("prod")}
          aria-pressed={!isStg}
          className={
            !isStg
              ? "bg-emerald-600 px-2 py-1 font-semibold text-white"
              : "bg-white px-2 py-1 text-ink-500 hover:bg-ink-50"
          }
        >
          PROD
        </button>
        <button
          type="button"
          data-testid="env-btn-stg"
          onClick={() => setEnv("stg")}
          aria-pressed={isStg}
          className={
            isStg
              ? "bg-amber-500 px-2 py-1 font-semibold text-white"
              : "bg-white px-2 py-1 text-ink-500 hover:bg-ink-50"
          }
        >
          STG
        </button>
      </div>
    </div>
  );
}
